import { on } from 'helpers/dom'
import { useEffect, useRef, useState } from 'preact/hooks'
import Icon from '../icon/icon'
import LoaderSpin from '../loader-spin/loader-spin'

function QuantityInput({ min = 0, max = 9999, quantity, setQuantity, disabled = false, isLoading = false, label = '', className = '', classError = '' }) {
  const [value, setValue] = useState(quantity)
  const [message, setMessage] = useState(null)
  const inputRef = useRef(null)

  const onChange = (count) => {
    const current = value + count
    if (current >= min && current <= max) {
      setValue(current)
      setQuantity(current)
    } else if (current > max) {
      changeMessage()
    }
  }

  const onValidate = (value) => {
    return /^\d+$/.test(value)
  }

  const onChangeInput = (e) => {
    e.preventDefault()
    const currentQuantity = parseInt(e.target.value)
    const isValidated = onValidate(currentQuantity)

    if (isNaN(currentQuantity)) {
      inputRef.current.value = value
      return
    }

    setValue(currentQuantity)

    if (inputRef && inputRef.current) {
      inputRef.current.value = currentQuantity
    }

    if (!isValidated) {
      if (currentQuantity !== 0 && currentQuantity < min) {
        setMessage('Enter a positive numbers')
      } else {
        setMessage('Enter only number')
      }
      return
    }

    if (currentQuantity <= max && currentQuantity >= 0) {
      setMessage(null)
      setQuantity(currentQuantity)
    } else {
      changeMessage()
    }
  }

  const changeMessage = () => {
    if (max > 1) {
      setMessage(`We have ${max} cartons`)
    } else {
      setMessage('We have only 1 carton')
    }
  }

  useEffect(() => {
    if (inputRef && inputRef.current) {
      on(
        'keydown',
        (event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            onChangeInput(event)
          }
        },
        inputRef.current
      )
    }
  }, [])

  return (
    <>
      <div className={`relative flex items-center justify-between border border-default rounded overflow-hidden ${className}`}>
        <button
          type="button"
          name="minus"
          className={`flex items-center justify-center p-2 w-10 h-10 ${value <= min || disabled || isLoading ? 'bg-grey-100' : ''}`}
          disabled={value <= min || disabled || isLoading}
          onClick={() => onChange(-1)}
        >
          <Icon name="icon-minus" viewBox="0 0 20 20" />
        </button>
        <div className="relative flex-auto flex flex-nowrap">
          {!isLoading ? (
            <>
              <input
                type="number"
                ref={inputRef}
                value={value}
                className="w-[18px] text-center border-none p-0 text-xs text-grey-900"
                min={min}
                max={max}
                step="1"
                onBlur={onChangeInput}
                readonly={disabled}
              />
              {label && <div className="inline-block text-label pl-1 tracking-normal capitalize text-grey-900">{label}{quantity > 1 && 's'}</div>}
            </>
          ) : (
            <LoaderSpin width="4" height="4" />
          )}
        </div>

        <button
          type="button"
          name="plus"
          className={`flex items-center justify-center p-2 w-10 h-10 ${value <= min || value === max || disabled || isLoading ? 'bg-grey-100' : ''}`}
          disabled={value <= min || disabled || isLoading}
          onClick={() => onChange(1)}
        >
          <Icon name="icon-plus" viewBox="0 0 20 20" />
        </button>
      </div>
      {message && <span className={`text-error text-xs ${classError}`}>{message}</span>}
    </>
  )
}

export default QuantityInput
